// dependencies
import { fromJS } from "immutable";

const UIState = fromJS({
	job: null,
});

export default UIState;
